import { api, prefix } from "@/api";
import type { AxiosRequestConfig } from "axios";
import type { roleType } from "@/types/role";
import { applicationType } from "@/types/application";

const namespace = "gaia";

export const getApplicationList = (config: AxiosRequestConfig = {}) => {
  return api<{ data: Array<any> }>({
    url: `${prefix}/${namespace}/profile/applications`,
    method: "get",
    ...config,
  });
};

export const getRoleList = (config: AxiosRequestConfig = {}) => {
  return api<Array<roleType>>({
    url: `${prefix}/${namespace}/profile/admin/role`,
    method: "get",
    ...config,
  });
};

export const getPlatformApplicationList = (config: AxiosRequestConfig = {}) => {
  return api<Array<applicationType>>({
    url: `${prefix}/platform/profile/application?extend=configuration`,
    method: "GET",
    ...config,
  });
};